import { Directive,ElementRef,HostListener,Input,Renderer,OnInit } from '@angular/core';
import * as utils from "../services/comment";
import { HttpBaseService } from "../services/httpBase.service";
import api from "../api";
import { LiteralMapEntry } from '@angular/compiler/src/output/output_ast';

/**
 * 跳转SAAFFRAME平台路由，a标签url处理
 * {"htmlUrl":"/articleManagementList",
 * "menuCode":"WZGL",
 * "menuDesc":"",
 * "menuId":2224,
 * "menuName":"文章管理",
 * "roleId":2,
 * "systemCode":"BRC",
 * "systemName":"BRC"
 * }
 *
 */
@Directive({
  selector: '[appGoLink]'
})
export class GoLinkDirective implements OnInit{
  @Input('data') data;
  constructor(private element:ElementRef,private renderer:Renderer,private http: HttpBaseService) {
    //this.element.nativeElement.onClick= function () {
    //  console.log(22)
    //}
  }
  ngOnInit(){
  }
  @HostListener('click') doSomethingClick(){
    let host = window.location.host
    //let successLoginInfo = JSON.parse(utils.GetStore("successLoginInfo"));
    //let certificate = successLoginInfo["certificate"];
    let menu=this.data
    
    let _urlobj = [{
      name: menu.menuName,
      url: menu.htmlUrl.replace('/',''),
      id: menu.menuId,
      active: true
    }]
    let headTab=menu.systemName +'_headTab'
    let certificate=menu.systemName +'_certificate'
    let successLoginInfo=menu.systemName +'_successLoginInfo'
    let languageList = menu.systemName +'_languageList'
    sessionStorage[headTab] = utils.Base64.encode(JSON.stringify(_urlobj));
    sessionStorage[certificate] = sessionStorage.getItem('certificate');
    sessionStorage[languageList] = sessionStorage.getItem('languageList');
    sessionStorage[successLoginInfo] = sessionStorage.getItem('successLoginInfo');
    localStorage[successLoginInfo] = sessionStorage.getItem('successLoginInfo');
    let _url = '//'+host+'/frame/#/'+menu.systemCode.toLowerCase() +'/main'
    this.http
      .post(api.menuClickCount, {
        params:JSON.stringify({menuId:menu.menuId})
      })
      .subscribe(res => {
      });
    this.renderer.setElementAttribute(this.element.nativeElement,'href',_url)
  }

}



// WEBPACK FOOTER //
// E:/project/muyiwang/svn/project-code/trad-portal/src/app/directives/go-link.directive.ts